import ImageOptimizer from '@/components/image-optimizer';
import { WhyCardProps } from '@/types/franchise.type';

export default function WhyCard({ title, description, icon }: WhyCardProps) {
  return (
    <div className="bg-bg-grayblue desktop:py-20 desktop:px-10 flex flex-col items-start justify-center rounded-2xl px-6 py-10">
      <div className="relative">
        <ImageOptimizer
          src={icon}
          alt="아이콘"
          width={40}
          height={40}
          className="desktop:w-14 desktop:h-14 h-10 w-10"
        />
      </div>
      <h3 className="typo-24 text-level-2 desktop:typo-26 desktop:pt-6 desktop:leading-snug pt-5 leading-relaxed font-extrabold whitespace-pre-line">
        {title}
      </h3>
      <p className="typo-16 text-level-4 desktop:typo-18 desktop:leading-snug desktop:pt-10 pt-6 leading-relaxed font-semibold whitespace-pre-line">
        {description}
      </p>
    </div>
  );
}
